import React from 'react';
import { Helmet } from 'react-helmet';
import { useSeoData } from 'component/common/SEOHelmet/useSeoData';

const SeoHelmet: React.FC<{ pageTypeId: number }> = ({ pageTypeId }) => {
    const seoData = useSeoData(pageTypeId);

    return (
        <Helmet>
            <title>{seoData.title}</title>
        </Helmet>
    );
};
SeoHelmet.displayName = 'SeoHelmet';

export default SeoHelmet;
